/**
 * @fileoverview POST handler for the "/app_settings/tag_upsert" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsTagUpsertCacheKeys } from "./constants";
import type { PostAppSettingsTagUpsertProps, AppSettingsTagUpsertResult } from "./types";

export const upsertAppSettingsTag = reactQueryMutationAdapter(
  appSettingsTagUpsertCacheKeys,
  (props: PostAppSettingsTagUpsertProps): Promise<AppSettingsTagUpsertResult> => {
    return fetch("/app_settings/tag_upsert", "POST", props);
  }
);
